import { AbstractControl } from '@angular/forms';

export class ConfirmacaoResenha {
  static MatchValidator(control: AbstractControl) {
    const senha: string = control.get('senha')?.value;
    const resenha: string = control.get('resenha')?.value;

    if (senha !== resenha) {
      control.get('resenha')?.setErrors({ diferente: true });
    }
    return null;
  }
}
